import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/RoleController/CreateRoleController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateUser({ role, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ RoleName: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    useEffect(() => {
        if (role) {
            setFormData({ RoleName: role.RoleName });
        } else {
            setFormData({ RoleName: '' }); // Clear form data when switching to add mode
        }
    }, [role]);
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (role) {
            formData.ID = role.RolesId;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="roleModal" tabIndex="-1" aria-labelledby="roleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{role ? t('editRole') : t('addRole')}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{"marginLeft":"5px","marginRight":"0px","marginTop":"10px"}}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">{t('role')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="RoleName" value={formData.RoleName} onChange={handleFieldChange} />
                                        {errors.RoleName && <div style={{ color: 'red' }}>{errors.RoleName}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                <i className="icofont-save" aria-hidden="true"> {role ? t('update') : t('save')}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                <i className="icofont-close" aria-hidden="true">  {t('close')}</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </form >
        </div >

    );
}

export default CreateUser;